// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-portal-page {
  --wallet-bg-1: #07131b;
  --wallet-bg-2: #0b1d29;
  --wallet-bg-3: #04080c;
  --wallet-emerald: #31e6a4;
  --wallet-gold: #f0ca73;
  --wallet-text: #f5f0e5;
  --wallet-text-soft: rgba(233, 238, 241, 0.74);
  --wallet-panel: rgba(7, 16, 22, 0.96);
  --wallet-border: rgba(100, 197, 170, 0.14);
  min-height: 100vh;
  min-height: 100dvh;
  padding:
    calc(18px + var(--app-safe-top, 0px))
    calc(18px + var(--app-safe-right, 0px))
    calc(44px + var(--app-safe-bottom, 0px))
    calc(18px + var(--app-safe-left, 0px));
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  color: var(--wallet-text);
  background:
    radial-gradient(circle at top center, rgba(53, 109, 92, 0.26) 0%, rgba(7, 19, 27, 0) 34%),
    radial-gradient(circle at 20% 80%, rgba(240, 202, 115, 0.1) 0%, rgba(7, 19, 27, 0) 28%),
    linear-gradient(180deg, var(--wallet-bg-1) 0%, var(--wallet-bg-2) 52%, var(--wallet-bg-3) 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;
}

.wallet-portal-page__texture {
  position: fixed;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.015) 1px, transparent 1px);
  background-size: 18px 18px;
  mask-image: radial-gradient(circle at center, rgba(0, 0, 0, 0.88) 35%, transparent 100%);
  opacity: 0.65;
}

.wallet-portal-topbar,
.wallet-portal-main {
  position: relative;
  z-index: 2;
}

.wallet-portal-topbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.wallet-portal-topbar__actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  width: min(100%, 280px);
  justify-content: end;
  align-items: start;
}

.wallet-portal-back,
.wallet-portal-chip,
.wallet-portal-card,
.wallet-portal-surface,
.wallet-portal-primary,
.wallet-portal-preset,
.wallet-portal-refresh,
.wallet-portal-list__item,
.wallet-portal-link {
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(180deg, rgba(14, 24, 31, 0.94) 0%, rgba(8, 15, 22, 0.98) 100%);
  color: var(--wallet-text);
  border-radius: 22px;
}

.wallet-portal-mode-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 38px;
  padding: 0 12px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(8, 15, 22, 0.92);
  color: #f5f0e5;
  font-size: 0.78rem;
  white-space: nowrap;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease, filter 160ms ease;
}

.wallet-portal-mode-link--active {
  border-color: rgba(49, 230, 164, 0.3);
  background: linear-gradient(180deg, rgba(49, 230, 164, 0.22) 0%, rgba(16, 68, 52, 0.88) 100%);
  color: #e7fff7;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.12),
    0 10px 20px rgba(0, 0, 0, 0.16);
}

.wallet-portal-back,
.wallet-portal-chip,
.wallet-portal-refresh,
.wallet-portal-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
}

.wallet-portal-back,
.wallet-portal-refresh,
.wallet-portal-primary,
.wallet-portal-preset,
.wallet-portal-list__item,
.wallet-portal-payload button,
.wallet-portal-link {
  cursor: pointer;
}

.wallet-portal-back {
  min-height: 38px;
  padding: 0 10px;
  font-size: 0.76rem;
  border-radius: 14px;
  background: rgba(8, 15, 22, 0.9);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease;
}

.wallet-portal-back:hover,
.wallet-portal-mode-link:hover {
  transform: translateY(-1px);
  border-color: rgba(49, 230, 164, 0.22);
  background: rgba(10, 19, 27, 0.98);
}

.wallet-portal-back svg,
.wallet-portal-mode-link svg {
  width: 14px;
  height: 14px;
  color: currentColor;
}

.wallet-portal-chip,
.wallet-portal-surface__header p,
.wallet-portal-card span,
.wallet-portal-tag {
  color: var(--wallet-gold);
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.62rem;
}

.wallet-portal-main {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.wallet-portal-summary {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.wallet-portal-card,
.wallet-portal-surface {
  padding: 16px;
  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.28);
}

.wallet-portal-card--club {
  display: grid;
  gap: 12px;
}

.wallet-portal-card__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.wallet-portal-card__row span,
.wallet-portal-card__value span,
.wallet-portal-card__note {
  color: var(--wallet-text-soft);
  text-transform: none;
  letter-spacing: 0;
}

.wallet-portal-card__row span,
.wallet-portal-card__value span {
  display: block;
  font-size: 0.66rem;
  text-transform: uppercase;
  letter-spacing: 0.14em;
}

.wallet-portal-card__row strong {
  display: block;
  margin-top: 6px;
  font-size: 0.98rem;
  line-height: 1.15;
}

.wallet-portal-card__value {
  text-align: right;
}

.wallet-portal-card__value strong {
  display: block;
  margin-top: 6px;
  font-size: clamp(1.05rem, 3.8vw, 1.45rem);
  line-height: 1.1;
}

.wallet-portal-card__note {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.45;
}

.wallet-portal-card p,
.wallet-portal-inline,
.wallet-portal-empty {
  margin: 10px 0 0;
  color: var(--wallet-text-soft);
  line-height: 1.55;
}

.wallet-portal-card--balance {
  border-color: rgba(49, 230, 164, 0.22);
}

.wallet-portal-surface__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.wallet-portal-surface__header h2 {
  margin: 0;
  font-size: 1rem;
}

.wallet-portal-tag {
  padding: 10px 12px;
  border-radius: 999px;
  border: 1px solid rgba(240, 202, 115, 0.18);
  background: rgba(240, 202, 115, 0.08);
}

.wallet-portal-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.wallet-portal-preset {
  padding: 10px 12px;
}

.wallet-portal-preset--active,
.wallet-portal-primary,
.wallet-portal-link {
  border-color: rgba(49, 230, 164, 0.3);
  background: linear-gradient(180deg, rgba(49, 230, 164, 0.22) 0%, rgba(16, 68, 52, 0.88) 100%);
  color: #e7fff7;
}

.wallet-portal-preset:disabled,
.wallet-portal-primary:disabled,
.wallet-portal-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.wallet-portal-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wallet-portal-field span,
.wallet-portal-meta dt {
  color: var(--wallet-text-soft);
  font-size: 0.84rem;
}

.wallet-portal-field__hint {
  display: block;
  color: rgba(233, 238, 241, 0.62);
  font-size: 0.78rem;
  line-height: 1.5;
}

.wallet-portal-field input,
.wallet-portal-field select,
.wallet-portal-payload textarea {
  min-height: 56px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
  color: var(--wallet-text);
  padding: 0 16px;
  font-size: 1.05rem;
}

.wallet-portal-payload textarea {
  width: 100%;
  min-height: 96px;
  resize: vertical;
  padding: 14px 16px;
}

.wallet-portal-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.wallet-portal-field--full {
  grid-column: 1 / -1;
}

.wallet-portal-primary {
  width: 100%;
  min-height: 50px;
  font-size: 0.96rem;
  font-weight: 700;
}

.wallet-portal-secondary {
  width: 100%;
  min-height: 50px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: var(--wallet-text);
  font-size: 0.96rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, opacity 0.18s ease;
}

.wallet-portal-secondary:hover:not(:disabled) {
  border-color: rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.07);
}

.wallet-portal-secondary--danger {
  border-color: rgba(255, 127, 114, 0.2);
  background: linear-gradient(180deg, rgba(255, 127, 114, 0.14) 0%, rgba(92, 24, 18, 0.88) 100%);
  color: #ffe1db;
}

.wallet-portal-secondary--danger:hover:not(:disabled) {
  border-color: rgba(255, 127, 114, 0.3);
  background: linear-gradient(180deg, rgba(255, 127, 114, 0.2) 0%, rgba(106, 28, 21, 0.92) 100%);
}

.wallet-portal-inline {
  padding: 12px 14px;
  border-radius: 16px;
  border: 1px solid transparent;
}

.wallet-portal-inline--success {
  border-color: rgba(49, 230, 164, 0.18);
  background: rgba(49, 230, 164, 0.08);
  color: #dffbf1;
}

.wallet-portal-inline--error {
  border-color: rgba(255, 127, 114, 0.18);
  background: rgba(255, 127, 114, 0.08);
  color: #ffd3cc;
}

.wallet-portal-inline--warning {
  border-color: rgba(240, 202, 115, 0.18);
  background: rgba(240, 202, 115, 0.08);
  color: #f6deb0;
}

.wallet-portal-surface .wallet-portal-inline + .wallet-portal-inline,
.wallet-portal-surface .wallet-portal-inline + .wallet-portal-primary,
.wallet-portal-surface .wallet-portal-form-grid + .wallet-portal-inline,
.wallet-portal-surface .wallet-portal-resolution + .wallet-portal-inline {
  margin-top: 12px;
}

.wallet-portal-card-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin-top: 16px;
}

.wallet-portal-intent {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.wallet-portal-intent__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.wallet-portal-intent__summary strong {
  display: block;
  margin-top: 6px;
  font-size: 2rem;
}

.wallet-portal-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
}

.wallet-portal-meta div {
  padding: 14px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.wallet-portal-meta dd {
  margin: 8px 0 0;
  font-weight: 600;
}

.wallet-portal-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 700;
}

.wallet-portal-status--warning {
  background: rgba(240, 202, 115, 0.12);
  color: #f0ca73;
}

.wallet-portal-status--success {
  background: rgba(49, 230, 164, 0.12);
  color: #31e6a4;
}

.wallet-portal-status--danger {
  background: rgba(255, 127, 114, 0.12);
  color: #ffb1a7;
}

.wallet-portal-status--neutral {
  background: rgba(255, 255, 255, 0.06);
  color: #f5f0e5;
}

.wallet-portal-qr {
  display: flex;
  justify-content: center;
}

.wallet-portal-qr img {
  width: min(100%, 260px);
  border-radius: 22px;
  padding: 16px;
  background: #fff;
}

.wallet-portal-payload {
  display: grid;
  gap: 10px;
}

.wallet-portal-payload button {
  min-height: 48px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: #f5f0e5;
}

.wallet-portal-resolution {
  display: grid;
  gap: 12px;
  padding: 18px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.wallet-portal-resolution--success {
  border-color: rgba(49, 230, 164, 0.18);
  background: linear-gradient(180deg, rgba(49, 230, 164, 0.08) 0%, rgba(49, 230, 164, 0.03) 100%);
}

.wallet-portal-resolution--danger {
  border-color: rgba(255, 127, 114, 0.18);
  background: linear-gradient(180deg, rgba(255, 127, 114, 0.08) 0%, rgba(255, 127, 114, 0.03) 100%);
}

.wallet-portal-resolution--warning,
.wallet-portal-resolution--neutral {
  border-color: rgba(240, 202, 115, 0.18);
  background: linear-gradient(180deg, rgba(240, 202, 115, 0.08) 0%, rgba(240, 202, 115, 0.03) 100%);
}

.wallet-portal-resolution__title {
  font-size: 1.02rem;
  line-height: 1.4;
}

.wallet-portal-resolution__hint {
  margin: 0;
  color: var(--wallet-text-soft);
  line-height: 1.6;
}

.wallet-portal-resolution__meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
}

.wallet-portal-resolution__meta div {
  padding: 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.wallet-portal-resolution__meta dt {
  color: var(--wallet-text-soft);
  font-size: 0.84rem;
}

.wallet-portal-resolution__meta dd {
  margin: 8px 0 0;
  font-weight: 700;
}

.wallet-portal-data-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.wallet-portal-data-grid__item {
  padding: 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.wallet-portal-data-grid__item span {
  display: block;
  color: var(--wallet-text-soft);
  font-size: 0.82rem;
}

.wallet-portal-data-grid__item strong {
  display: block;
  margin-top: 8px;
  line-height: 1.45;
}

.wallet-portal-guidance {
  display: grid;
  gap: 10px;
  padding: 16px 18px;
  border-radius: 18px;
  border: 1px solid rgba(240, 202, 115, 0.14);
  background: rgba(240, 202, 115, 0.06);
}

.wallet-portal-guidance h3 {
  margin: 0;
  font-size: 0.98rem;
  color: #f5f0e5;
}

.wallet-portal-guidance ul {
  margin: 0;
  padding-left: 18px;
  color: var(--wallet-text-soft);
  line-height: 1.6;
}

.wallet-portal-list {
  display: grid;
  gap: 10px;
}

.wallet-portal-list__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  text-align: left;
}

.wallet-portal-list__item--active {
  border-color: rgba(49, 230, 164, 0.3);
}

.wallet-portal-list__copy strong {
  display: block;
}

.wallet-portal-list__copy span {
  color: var(--wallet-text-soft);
  font-size: 0.9rem;
}

.wallet-portal-loading {
  display: grid;
  gap: 14px;
  padding: 20px;
}

.wallet-portal-loading__line,
.wallet-portal-loading__card {
  border-radius: 18px;
  background: linear-gradient(90deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.03) 100%);
  background-size: 200% 100%;
  animation: walletShimmer 1.4s linear infinite;
}

.wallet-portal-loading__line--short {
  width: 160px;
  height: 20px;
}

.wallet-portal-loading__line--wide {
  width: min(100%, 480px);
  height: 42px;
}

.wallet-portal-loading__card {
  height: 220px;
}

.wallet-portal-modal {
  position: fixed;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  padding:
    calc(20px + var(--app-safe-top, 0px))
    calc(20px + var(--app-safe-right, 0px))
    calc(20px + var(--app-safe-bottom, 0px))
    calc(20px + var(--app-safe-left, 0px));
}

.wallet-portal-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(2, 6, 10, 0.78);
  backdrop-filter: blur(10px);
}

.wallet-portal-modal__sheet {
  position: relative;
  z-index: 1;
  width: min(720px, 100%);
  max-height: min(88vh, 88dvh);
  overflow-y: auto;
  display: grid;
  gap: 16px;
  padding: 22px;
  border-radius: 26px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(180deg, rgba(14, 24, 31, 0.98) 0%, rgba(8, 15, 22, 0.99) 100%);
  box-shadow: 0 32px 72px rgba(0, 0, 0, 0.46);
}

.wallet-portal-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.wallet-portal-modal__header p {
  margin: 0 0 6px;
  color: var(--wallet-gold);
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.72rem;
}

.wallet-portal-modal__header h2 {
  margin: 0;
  font-size: 1.22rem;
}

.wallet-portal-modal__close {
  min-height: 44px;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: var(--wallet-text);
  cursor: pointer;
}

.wallet-portal-modal__body {
  display: grid;
  gap: 16px;
}

@keyframes walletShimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

@media (max-width: 820px) {
  .wallet-portal-grid,
  .wallet-portal-meta,
  .wallet-portal-resolution__meta,
  .wallet-portal-form-grid,
  .wallet-portal-data-grid {
    grid-template-columns: 1fr;
  }

  .wallet-portal-intent__summary,
  .wallet-portal-surface__header,
  .wallet-portal-modal__header {
    flex-direction: column;
    align-items: stretch;
  }

  .wallet-portal-topbar {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 8px;
    align-items: start;
  }

  .wallet-portal-card-actions {
    justify-content: stretch;
  }

  .wallet-portal-topbar__actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
    justify-content: stretch;
    width: 100%;
  }

  .wallet-portal-mode-link {
    width: 100%;
    min-height: 36px;
    padding: 0 8px;
    font-size: 0.68rem;
    line-height: 1.02;
    white-space: normal;
    text-align: center;
  }

  .wallet-portal-back {
    min-height: 36px;
    padding: 0 10px;
    font-size: 0.72rem;
    border-radius: 12px;
    align-self: start;
  }

  .wallet-portal-back svg,
  .wallet-portal-mode-link svg {
    width: 14px;
    height: 14px;
  }

  .wallet-portal-card__row {
    gap: 10px;
  }

  .wallet-portal-card__row strong {
    font-size: 0.92rem;
  }

  .wallet-portal-card__value strong {
    font-size: 1.14rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ClubWalletPortalPage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,6CAA6C;EAC7C,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB;;;;0CAIwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB;;;mGAGiG;EACjG,wFAAwF;AAC1F;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB;;2EAEyE;EACzE,0BAA0B;EAC1B,wFAAwF;EACxF,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,2CAA2C;EAC3C,0FAA0F;EAC1F,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;EACnD,mGAAmG;AACrG;;AAEA;EACE,qCAAqC;EACrC,6FAA6F;EAC7F,cAAc;EACd;;mCAEiC;AACnC;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,mDAAmD;EACnD,gFAAgF;AAClF;;AAEA;;EAEE,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;EAIE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;EAGE,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,qCAAqC;EACrC,6FAA6F;EAC7F,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,8FAA8F;EAC9F,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,8FAA8F;AAChG;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,+FAA+F;AACjG;;AAEA;EACE,uCAAuC;EACvC,iGAAiG;AACnG;;AAEA;;EAEE,uCAAuC;EACvC,iGAAiG;AACnG;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,sHAAsH;EACtH,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;;0CAIwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,0FAA0F;EAC1F,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;;EAEA;;;IAGE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,wBAAwB;IACxB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".wallet-portal-page {\n  --wallet-bg-1: #07131b;\n  --wallet-bg-2: #0b1d29;\n  --wallet-bg-3: #04080c;\n  --wallet-emerald: #31e6a4;\n  --wallet-gold: #f0ca73;\n  --wallet-text: #f5f0e5;\n  --wallet-text-soft: rgba(233, 238, 241, 0.74);\n  --wallet-panel: rgba(7, 16, 22, 0.96);\n  --wallet-border: rgba(100, 197, 170, 0.14);\n  min-height: 100vh;\n  min-height: 100dvh;\n  padding:\n    calc(18px + var(--app-safe-top, 0px))\n    calc(18px + var(--app-safe-right, 0px))\n    calc(44px + var(--app-safe-bottom, 0px))\n    calc(18px + var(--app-safe-left, 0px));\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  color: var(--wallet-text);\n  background:\n    radial-gradient(circle at top center, rgba(53, 109, 92, 0.26) 0%, rgba(7, 19, 27, 0) 34%),\n    radial-gradient(circle at 20% 80%, rgba(240, 202, 115, 0.1) 0%, rgba(7, 19, 27, 0) 28%),\n    linear-gradient(180deg, var(--wallet-bg-1) 0%, var(--wallet-bg-2) 52%, var(--wallet-bg-3) 100%);\n  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;\n}\n\n.wallet-portal-page__texture {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.015) 1px, transparent 1px);\n  background-size: 18px 18px;\n  mask-image: radial-gradient(circle at center, rgba(0, 0, 0, 0.88) 35%, transparent 100%);\n  opacity: 0.65;\n}\n\n.wallet-portal-topbar,\n.wallet-portal-main {\n  position: relative;\n  z-index: 2;\n}\n\n.wallet-portal-topbar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.wallet-portal-topbar__actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  width: min(100%, 280px);\n  justify-content: end;\n  align-items: start;\n}\n\n.wallet-portal-back,\n.wallet-portal-chip,\n.wallet-portal-card,\n.wallet-portal-surface,\n.wallet-portal-primary,\n.wallet-portal-preset,\n.wallet-portal-refresh,\n.wallet-portal-list__item,\n.wallet-portal-link {\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: linear-gradient(180deg, rgba(14, 24, 31, 0.94) 0%, rgba(8, 15, 22, 0.98) 100%);\n  color: var(--wallet-text);\n  border-radius: 22px;\n}\n\n.wallet-portal-mode-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 38px;\n  padding: 0 12px;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(8, 15, 22, 0.92);\n  color: #f5f0e5;\n  font-size: 0.78rem;\n  white-space: nowrap;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);\n  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease, filter 160ms ease;\n}\n\n.wallet-portal-mode-link--active {\n  border-color: rgba(49, 230, 164, 0.3);\n  background: linear-gradient(180deg, rgba(49, 230, 164, 0.22) 0%, rgba(16, 68, 52, 0.88) 100%);\n  color: #e7fff7;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.12),\n    0 10px 20px rgba(0, 0, 0, 0.16);\n}\n\n.wallet-portal-back,\n.wallet-portal-chip,\n.wallet-portal-refresh,\n.wallet-portal-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 10px;\n}\n\n.wallet-portal-back,\n.wallet-portal-refresh,\n.wallet-portal-primary,\n.wallet-portal-preset,\n.wallet-portal-list__item,\n.wallet-portal-payload button,\n.wallet-portal-link {\n  cursor: pointer;\n}\n\n.wallet-portal-back {\n  min-height: 38px;\n  padding: 0 10px;\n  font-size: 0.76rem;\n  border-radius: 14px;\n  background: rgba(8, 15, 22, 0.9);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);\n  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease;\n}\n\n.wallet-portal-back:hover,\n.wallet-portal-mode-link:hover {\n  transform: translateY(-1px);\n  border-color: rgba(49, 230, 164, 0.22);\n  background: rgba(10, 19, 27, 0.98);\n}\n\n.wallet-portal-back svg,\n.wallet-portal-mode-link svg {\n  width: 14px;\n  height: 14px;\n  color: currentColor;\n}\n\n.wallet-portal-chip,\n.wallet-portal-surface__header p,\n.wallet-portal-card span,\n.wallet-portal-tag {\n  color: var(--wallet-gold);\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  font-size: 0.62rem;\n}\n\n.wallet-portal-main {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.wallet-portal-summary {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n.wallet-portal-card,\n.wallet-portal-surface {\n  padding: 16px;\n  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.28);\n}\n\n.wallet-portal-card--club {\n  display: grid;\n  gap: 12px;\n}\n\n.wallet-portal-card__row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.wallet-portal-card__row span,\n.wallet-portal-card__value span,\n.wallet-portal-card__note {\n  color: var(--wallet-text-soft);\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.wallet-portal-card__row span,\n.wallet-portal-card__value span {\n  display: block;\n  font-size: 0.66rem;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n}\n\n.wallet-portal-card__row strong {\n  display: block;\n  margin-top: 6px;\n  font-size: 0.98rem;\n  line-height: 1.15;\n}\n\n.wallet-portal-card__value {\n  text-align: right;\n}\n\n.wallet-portal-card__value strong {\n  display: block;\n  margin-top: 6px;\n  font-size: clamp(1.05rem, 3.8vw, 1.45rem);\n  line-height: 1.1;\n}\n\n.wallet-portal-card__note {\n  margin: 0;\n  font-size: 0.78rem;\n  line-height: 1.45;\n}\n\n.wallet-portal-card p,\n.wallet-portal-inline,\n.wallet-portal-empty {\n  margin: 10px 0 0;\n  color: var(--wallet-text-soft);\n  line-height: 1.55;\n}\n\n.wallet-portal-card--balance {\n  border-color: rgba(49, 230, 164, 0.22);\n}\n\n.wallet-portal-surface__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.wallet-portal-surface__header h2 {\n  margin: 0;\n  font-size: 1rem;\n}\n\n.wallet-portal-tag {\n  padding: 10px 12px;\n  border-radius: 999px;\n  border: 1px solid rgba(240, 202, 115, 0.18);\n  background: rgba(240, 202, 115, 0.08);\n}\n\n.wallet-portal-presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.wallet-portal-preset {\n  padding: 10px 12px;\n}\n\n.wallet-portal-preset--active,\n.wallet-portal-primary,\n.wallet-portal-link {\n  border-color: rgba(49, 230, 164, 0.3);\n  background: linear-gradient(180deg, rgba(49, 230, 164, 0.22) 0%, rgba(16, 68, 52, 0.88) 100%);\n  color: #e7fff7;\n}\n\n.wallet-portal-preset:disabled,\n.wallet-portal-primary:disabled,\n.wallet-portal-secondary:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.wallet-portal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.wallet-portal-field span,\n.wallet-portal-meta dt {\n  color: var(--wallet-text-soft);\n  font-size: 0.84rem;\n}\n\n.wallet-portal-field__hint {\n  display: block;\n  color: rgba(233, 238, 241, 0.62);\n  font-size: 0.78rem;\n  line-height: 1.5;\n}\n\n.wallet-portal-field input,\n.wallet-portal-field select,\n.wallet-portal-payload textarea {\n  min-height: 56px;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n  color: var(--wallet-text);\n  padding: 0 16px;\n  font-size: 1.05rem;\n}\n\n.wallet-portal-payload textarea {\n  width: 100%;\n  min-height: 96px;\n  resize: vertical;\n  padding: 14px 16px;\n}\n\n.wallet-portal-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.wallet-portal-field--full {\n  grid-column: 1 / -1;\n}\n\n.wallet-portal-primary {\n  width: 100%;\n  min-height: 50px;\n  font-size: 0.96rem;\n  font-weight: 700;\n}\n\n.wallet-portal-secondary {\n  width: 100%;\n  min-height: 50px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--wallet-text);\n  font-size: 0.96rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.18s ease, border-color 0.18s ease, opacity 0.18s ease;\n}\n\n.wallet-portal-secondary:hover:not(:disabled) {\n  border-color: rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.wallet-portal-secondary--danger {\n  border-color: rgba(255, 127, 114, 0.2);\n  background: linear-gradient(180deg, rgba(255, 127, 114, 0.14) 0%, rgba(92, 24, 18, 0.88) 100%);\n  color: #ffe1db;\n}\n\n.wallet-portal-secondary--danger:hover:not(:disabled) {\n  border-color: rgba(255, 127, 114, 0.3);\n  background: linear-gradient(180deg, rgba(255, 127, 114, 0.2) 0%, rgba(106, 28, 21, 0.92) 100%);\n}\n\n.wallet-portal-inline {\n  padding: 12px 14px;\n  border-radius: 16px;\n  border: 1px solid transparent;\n}\n\n.wallet-portal-inline--success {\n  border-color: rgba(49, 230, 164, 0.18);\n  background: rgba(49, 230, 164, 0.08);\n  color: #dffbf1;\n}\n\n.wallet-portal-inline--error {\n  border-color: rgba(255, 127, 114, 0.18);\n  background: rgba(255, 127, 114, 0.08);\n  color: #ffd3cc;\n}\n\n.wallet-portal-inline--warning {\n  border-color: rgba(240, 202, 115, 0.18);\n  background: rgba(240, 202, 115, 0.08);\n  color: #f6deb0;\n}\n\n.wallet-portal-surface .wallet-portal-inline + .wallet-portal-inline,\n.wallet-portal-surface .wallet-portal-inline + .wallet-portal-primary,\n.wallet-portal-surface .wallet-portal-form-grid + .wallet-portal-inline,\n.wallet-portal-surface .wallet-portal-resolution + .wallet-portal-inline {\n  margin-top: 12px;\n}\n\n.wallet-portal-card-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  margin-top: 16px;\n}\n\n.wallet-portal-intent {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.wallet-portal-intent__summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.wallet-portal-intent__summary strong {\n  display: block;\n  margin-top: 6px;\n  font-size: 2rem;\n}\n\n.wallet-portal-meta {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin: 0;\n}\n\n.wallet-portal-meta div {\n  padding: 14px;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.wallet-portal-meta dd {\n  margin: 8px 0 0;\n  font-weight: 600;\n}\n\n.wallet-portal-status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 38px;\n  padding: 0 14px;\n  border-radius: 999px;\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.wallet-portal-status--warning {\n  background: rgba(240, 202, 115, 0.12);\n  color: #f0ca73;\n}\n\n.wallet-portal-status--success {\n  background: rgba(49, 230, 164, 0.12);\n  color: #31e6a4;\n}\n\n.wallet-portal-status--danger {\n  background: rgba(255, 127, 114, 0.12);\n  color: #ffb1a7;\n}\n\n.wallet-portal-status--neutral {\n  background: rgba(255, 255, 255, 0.06);\n  color: #f5f0e5;\n}\n\n.wallet-portal-qr {\n  display: flex;\n  justify-content: center;\n}\n\n.wallet-portal-qr img {\n  width: min(100%, 260px);\n  border-radius: 22px;\n  padding: 16px;\n  background: #fff;\n}\n\n.wallet-portal-payload {\n  display: grid;\n  gap: 10px;\n}\n\n.wallet-portal-payload button {\n  min-height: 48px;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.04);\n  color: #f5f0e5;\n}\n\n.wallet-portal-resolution {\n  display: grid;\n  gap: 12px;\n  padding: 18px;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.wallet-portal-resolution--success {\n  border-color: rgba(49, 230, 164, 0.18);\n  background: linear-gradient(180deg, rgba(49, 230, 164, 0.08) 0%, rgba(49, 230, 164, 0.03) 100%);\n}\n\n.wallet-portal-resolution--danger {\n  border-color: rgba(255, 127, 114, 0.18);\n  background: linear-gradient(180deg, rgba(255, 127, 114, 0.08) 0%, rgba(255, 127, 114, 0.03) 100%);\n}\n\n.wallet-portal-resolution--warning,\n.wallet-portal-resolution--neutral {\n  border-color: rgba(240, 202, 115, 0.18);\n  background: linear-gradient(180deg, rgba(240, 202, 115, 0.08) 0%, rgba(240, 202, 115, 0.03) 100%);\n}\n\n.wallet-portal-resolution__title {\n  font-size: 1.02rem;\n  line-height: 1.4;\n}\n\n.wallet-portal-resolution__hint {\n  margin: 0;\n  color: var(--wallet-text-soft);\n  line-height: 1.6;\n}\n\n.wallet-portal-resolution__meta {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin: 0;\n}\n\n.wallet-portal-resolution__meta div {\n  padding: 14px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.wallet-portal-resolution__meta dt {\n  color: var(--wallet-text-soft);\n  font-size: 0.84rem;\n}\n\n.wallet-portal-resolution__meta dd {\n  margin: 8px 0 0;\n  font-weight: 700;\n}\n\n.wallet-portal-data-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.wallet-portal-data-grid__item {\n  padding: 14px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.wallet-portal-data-grid__item span {\n  display: block;\n  color: var(--wallet-text-soft);\n  font-size: 0.82rem;\n}\n\n.wallet-portal-data-grid__item strong {\n  display: block;\n  margin-top: 8px;\n  line-height: 1.45;\n}\n\n.wallet-portal-guidance {\n  display: grid;\n  gap: 10px;\n  padding: 16px 18px;\n  border-radius: 18px;\n  border: 1px solid rgba(240, 202, 115, 0.14);\n  background: rgba(240, 202, 115, 0.06);\n}\n\n.wallet-portal-guidance h3 {\n  margin: 0;\n  font-size: 0.98rem;\n  color: #f5f0e5;\n}\n\n.wallet-portal-guidance ul {\n  margin: 0;\n  padding-left: 18px;\n  color: var(--wallet-text-soft);\n  line-height: 1.6;\n}\n\n.wallet-portal-list {\n  display: grid;\n  gap: 10px;\n}\n\n.wallet-portal-list__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 18px;\n  text-align: left;\n}\n\n.wallet-portal-list__item--active {\n  border-color: rgba(49, 230, 164, 0.3);\n}\n\n.wallet-portal-list__copy strong {\n  display: block;\n}\n\n.wallet-portal-list__copy span {\n  color: var(--wallet-text-soft);\n  font-size: 0.9rem;\n}\n\n.wallet-portal-loading {\n  display: grid;\n  gap: 14px;\n  padding: 20px;\n}\n\n.wallet-portal-loading__line,\n.wallet-portal-loading__card {\n  border-radius: 18px;\n  background: linear-gradient(90deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.03) 100%);\n  background-size: 200% 100%;\n  animation: walletShimmer 1.4s linear infinite;\n}\n\n.wallet-portal-loading__line--short {\n  width: 160px;\n  height: 20px;\n}\n\n.wallet-portal-loading__line--wide {\n  width: min(100%, 480px);\n  height: 42px;\n}\n\n.wallet-portal-loading__card {\n  height: 220px;\n}\n\n.wallet-portal-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding:\n    calc(20px + var(--app-safe-top, 0px))\n    calc(20px + var(--app-safe-right, 0px))\n    calc(20px + var(--app-safe-bottom, 0px))\n    calc(20px + var(--app-safe-left, 0px));\n}\n\n.wallet-portal-modal__backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(2, 6, 10, 0.78);\n  backdrop-filter: blur(10px);\n}\n\n.wallet-portal-modal__sheet {\n  position: relative;\n  z-index: 1;\n  width: min(720px, 100%);\n  max-height: min(88vh, 88dvh);\n  overflow-y: auto;\n  display: grid;\n  gap: 16px;\n  padding: 22px;\n  border-radius: 26px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: linear-gradient(180deg, rgba(14, 24, 31, 0.98) 0%, rgba(8, 15, 22, 0.99) 100%);\n  box-shadow: 0 32px 72px rgba(0, 0, 0, 0.46);\n}\n\n.wallet-portal-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.wallet-portal-modal__header p {\n  margin: 0 0 6px;\n  color: var(--wallet-gold);\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  font-size: 0.72rem;\n}\n\n.wallet-portal-modal__header h2 {\n  margin: 0;\n  font-size: 1.22rem;\n}\n\n.wallet-portal-modal__close {\n  min-height: 44px;\n  padding: 0 16px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--wallet-text);\n  cursor: pointer;\n}\n\n.wallet-portal-modal__body {\n  display: grid;\n  gap: 16px;\n}\n\n@keyframes walletShimmer {\n  from { background-position: 200% 0; }\n  to { background-position: -200% 0; }\n}\n\n@media (max-width: 820px) {\n  .wallet-portal-grid,\n  .wallet-portal-meta,\n  .wallet-portal-resolution__meta,\n  .wallet-portal-form-grid,\n  .wallet-portal-data-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .wallet-portal-intent__summary,\n  .wallet-portal-surface__header,\n  .wallet-portal-modal__header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .wallet-portal-topbar {\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr);\n    gap: 8px;\n    align-items: start;\n  }\n\n  .wallet-portal-card-actions {\n    justify-content: stretch;\n  }\n\n  .wallet-portal-topbar__actions {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 6px;\n    justify-content: stretch;\n    width: 100%;\n  }\n\n  .wallet-portal-mode-link {\n    width: 100%;\n    min-height: 36px;\n    padding: 0 8px;\n    font-size: 0.68rem;\n    line-height: 1.02;\n    white-space: normal;\n    text-align: center;\n  }\n\n  .wallet-portal-back {\n    min-height: 36px;\n    padding: 0 10px;\n    font-size: 0.72rem;\n    border-radius: 12px;\n    align-self: start;\n  }\n\n  .wallet-portal-back svg,\n  .wallet-portal-mode-link svg {\n    width: 14px;\n    height: 14px;\n  }\n\n  .wallet-portal-card__row {\n    gap: 10px;\n  }\n\n  .wallet-portal-card__row strong {\n    font-size: 0.92rem;\n  }\n\n  .wallet-portal-card__value strong {\n    font-size: 1.14rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
